import React, { FC, useContext } from 'react';
import { ProductOut } from '../../../store/api';
import { SelectProductButton } from './SelectProductButton';
import { Link } from 'react-router-dom';
import ProductCover from '../../../shared/common/ProductCover';
import { SelectionContext } from '../context/SelectionContext';

export const ProductCoverCell: FC<{ product: ProductOut; isInSelectionMode: boolean; isSelectAll: boolean }> = ({
    product,
    isInSelectionMode,
    isSelectAll
}) => {
    const { selectSingleProduct } = useContext(SelectionContext);

    const productLink = !isInSelectionMode ? `/products/${product.id}` : '#';

    return (
        <td className="product-cover-cell packshot">
            {isInSelectionMode || isSelectAll ? <SelectProductButton product={product} /> : null}
            <Link
                to={productLink}
                onClick={
                    isInSelectionMode
                        ? e => {
                              e.preventDefault();
                              selectSingleProduct(product.id!);
                          }
                        : undefined
                }
            >
                <ProductCover product={product} minSizeInPx={157} />
            </Link>
        </td>
    );
};
